export default {
    message: {
        tiers: {
            t1: {
                label: "Autônomo",
                desc: "<p>O acesso unificado a todos os aplicativos virtuais, web e SaaS protege os usuários, aplicativos e dados com controles de segurança contextuais ponta a ponta.</p><p>Fornece proxy sem VPN e logon único para aplicativos da web, SaaS, virtuais e móveis, bem como proteção contra conteúdo malicioso, keyloggers e malware de captura de tela.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>A solução completa para funcionários que precisam de um espaço de trabalho digital completo, com segurança granular, mas que não demandam aplicativos e desktops virtuais.</p><p>Inclui a funcionalidade do Workspace Standard, além de controles avançados de segurança para SaaS e web, gerenciamento de endpoint unificado e o Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Solução abrangente de espaço de trabalho que inclui opções de implantação híbrida para o Citrix Virtual Apps and Desktops.</p><p>Inclui a funcionalidade Workspace Premium, além de uma opção de gerenciamento de nuvem para o Citrix Virtual Apps and Desktops.</p>"
            }
        }
    }
}